import React, { useEffect, useState } from "react";
import { getVisitsDetails, updateVisitRemark } from "_controllers/officer";
import { DateTime } from "luxon";
import { useParams } from "react-router-dom";
import haversine from "haversine-distance";
import {
  Button,
  CircularProgress,
  Grid,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import FlagIcon from '@mui/icons-material/Flag';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box } from "@mui/system";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";
import RoomIcon from '@mui/icons-material/Room';
import './VisitList.css'
import { toastMessage } from "utils/toastMessage";
import { useSelector } from "react-redux";

const VisitsList = () => {
  const { SAP_ID } = useParams();
  const { user } = useSelector((state) => state.user);

  const [Values, setValues] = useState({
    selectStartDate: '',
    selectEndDate: '',
  });

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [dealers, setDealers] = useState([]);
  const [message, setMessage] = useState("");
  const [visitDetails, setVisitDetails] = useState([])
  const [csvData, setCsvData] = useState([]);
  const [lat, setLat] = useState('')
  const [long, setLong] = useState('')
  const [openLoc, setOpenLoc] = useState(false);
  const [addRemark, setAddRemark] = useState(false)
  const [visitId, setVisitId] = useState('')
  const [visitRemark, setVisitRemark] = useState('')

  const messageStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#ffffff',
    border: "none",
    pt: 2,
    pb: 0,
    pl: 4,
    pr: 4,
    textAlign: 'left',
    letterSpacing: 1
  };

  const messageStyleLoc = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    // maxWidth: 500,
    bgcolor: "white",
    boxShadow: 24,
    p: 2,
    textAlign: 'center'
  };

  const fileName = `${SAP_ID}-visits`;

  useEffect(async () => {
    const start = startDate
      ? startDate
      : moment().startOf("month").format("YYYY-MM-DD");

    const end = endDate
      ? endDate
      : moment().endOf("month").format("YYYY-MM-DD");
    const plan = await getVisitsDetails({
      SAP_ID,
      start,
      end,
    });
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
    setMessage('')
  }, [message]);

  const handleClose = () => {
    setOpen(false);
    setOpenLoc(false)
  };

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value })
  }

  const { selectStartDate, selectEndDate } = Values

  const handleSubmit = async (e) => {
    e.preventDefault()
    const plan = await getVisitsDetails({
      SAP_ID,
      start: selectStartDate,
      end: selectEndDate,
    });
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }

  const calculateDistance = (coordinates) => {
    const { lat1, long1, lat2, long2 } = coordinates
    const distance = haversine({ lat: lat1, lng: long1 }, { lat: lat2, lng: long2 })
    return isNaN(distance) ? "NA" : distance.toFixed(0)
  }

  const approvedStyle = {
    color: 'green',
    fontWeight: "bolder"
  }

  const revertedStyle = {
    color: "red",
    fontWeight: "bolder"
  }

  const generateExcel = async (e) => {
    e.preventDefault()
    const visitact = []

    exportExcel(csvData.map((x) => {
      let temp = {}
      x?.visitRemark && x?.visitRemark.length > 0 ? x?.visitRemark.map((item, idx) => {
        item.role === "ZO" ?
          temp[`Visit_Remark_${idx + 1}`] = `ZM -${item.remark}` :
          (item.role === "ADMIN" ?
            temp[`Visit_Remark_${idx + 1}`] = `Sr VP Sales -${item.remark}` :
            (
              item.role === "RO" ?
                temp[`Visit_Remark_${idx + 1}`] = `RM -${item.remark}` :
                temp[`Visit_Remark_${idx + 1}`] = `AM -${item.remark}`
            )
          )

      }) : null

      let coordinates = {
        lat1: x?.startVisitLocation?.lat
          ? x?.startVisitLocation?.lat
          : 0,
        long1: x?.startVisitLocation?.long
          ? x?.startVisitLocation?.long
          : 0,
        lat2: x?.endVisitLocation?.lat
          ? x?.endVisitLocation?.lat
          : 0,
        long2: x?.endVisitLocation?.long
          ? x?.endVisitLocation?.long
          : 0
      }

      // console.log("temo", tempObj);

      return {
        'SAP ID': x?.SAP_ID,
        "Dealer Code": x.dealerCode,
        'Start Time': moment.utc(x.startTime).format("HH:mm"),
        'End Time': moment.utc(x.endTime).format("HH:mm"),
        "Start Date": moment.utc(x?.startTime).format("DD-MM-YYYY"),
        "End Date": x?.endTime ? moment.utc(x?.endTime).format("DD-MM-YYYY") : "NA",
        'Completed': x?.completed,
        "Remarks": x?.remark ? x.remark : "NA",
        "Start Location": `Lat : ${x.startVisitLocation.lat}, Long : ${x.startVisitLocation.long}`,
        "End Location": `Lat : ${x.endVisitLocation.lat}, Long : ${x.endVisitLocation.long}`,
        "Time Spent (mins)": moment.duration((moment(x.endTime ? x.endTime : "")).diff((moment(x.startTime ? x.startTime : "")))).asMinutes().toFixed(0),
        "Visit Type": x?.unplanned ? "Unplanned" : "Planned",
        "Distance Flag": calculateDistance(coordinates) < 100 ? "< 100 m" : ">100 m",
        ...temp
      }
    }), fileName)
  }

  const submitRemark = async () => {
    if (visitRemark === "")
      return alert("Remark Field Is Empty.");
    const data = await updateVisitRemark({
      id: visitId,
      remark: visitRemark
    });
    setAddRemark(false)
    setVisitRemark("")
    setVisitId('')
    setMessage(data?.message);
    toastMessage("Remark Added Successfully", "success")
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <form onSubmit={handleSubmit}>
          <Grid container xs={12} sx={{ m: 1 }}>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>Start Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectStartDate}
                  name="selectStartDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>End Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectEndDate}
                  name="selectEndDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <FilterAltOutlinedIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={handleSubmit} />
              <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
            </Grid>
          </Grid>
        </form>
      </Box>
      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mt: 3, mb: 2.5 }} >
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell align="left" sx={{ fontWeight: 'bolder' }}>SAP_ID</TableCell> */}
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Dealer Code</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Status</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Start Location</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>End Location</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Start Time</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>End Time</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Visit Action</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Flag</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Type</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Remark</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length > 0
                  ? data?.map((d) => (
                    <TableRow key={d._id}>
                      {/* <TableCell align="left">{d?.SAP_ID}</TableCell> */}
                      <TableCell align="left">
                        <div className="tooltip1" style={{ cursor: 'pointer' }}>{d?.dealerCode}
                          <span className="tooltiptext1">{d?.dealerName}</span>
                        </div>
                      </TableCell>
                      <TableCell align="center">
                        {d?.completed ? "Completed" : "Pending"}
                      </TableCell>
                      <TableCell align="center">
                        <div className="tooltip" style={{ cursor: "pointer" }} onClick={() => {
                          setOpenLoc(true);
                          setLat(d?.startVisitLocation?.lat
                            ? d?.startVisitLocation?.lat
                            : "NA")
                          setLong(d?.startVisitLocation?.long
                            ? d?.startVisitLocation?.long
                            : "NA")
                        }}>
                          <RoomIcon color="primary" />
                          {/* <span>
                            lat :{" "}
                            {d?.startVisitLocation?.lat
                              ? d?.startVisitLocation?.lat
                              : "NA"}
                          </span>
                          <span>
                            long :{" "}
                            {d?.startVisitLocation?.long
                              ? d?.startVisitLocation?.long
                              : "NA"}
                          </span> */}
                        </div>
                        {/* <p>
                          lat :{" "}
                          {d?.startVisitLocation?.lat
                            ? d?.startVisitLocation?.lat.toFixed(2)
                            : "NA"}
                        </p>
                        <p>
                          long :{" "}
                          {d?.startVisitLocation?.long
                            ? d?.startVisitLocation?.long.toFixed(2)
                            : "NA"}
                        </p> */}
                      </TableCell>
                      <TableCell align="center">
                        <div className="tooltip" style={{ cursor: "pointer" }} onClick={() => {
                          setOpenLoc(true);
                          setLat(d?.endVisitLocation?.lat
                            ? d?.endVisitLocation?.lat
                            : "NA")
                          setLong(d?.endVisitLocation?.long
                            ? d?.endVisitLocation?.long
                            : "NA")
                        }}>
                          <RoomIcon color="secondary" />
                          {/* <span>
                            lat :{" "}
                            {d?.endVisitLocation?.lat
                              ? d?.endVisitLocation?.lat
                              : "NA"}
                          </span>
                          <span>
                            long :{" "}
                            {d?.endVisitLocation?.long
                              ? d?.endVisitLocation?.long
                              : "NA"}
                          </span> */}
                        </div>
                      </TableCell>
                      <TableCell align="center">
                        {d?.startTime ? moment.utc(d?.startTime).format("DD-MM-YY hh:mm A") : "-"}
                      </TableCell>
                      <TableCell align="center">
                        {d?.endTime ? moment.utc(d?.endTime).format("DD-MM-YY hh:mm A") : "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpen(true);
                          setDealers(d?.dealers);
                          setVisitDetails(d?.visitActions)
                        }}
                      >
                        <VisibilityIcon
                          style={{ cursor: 'pointer' }}
                          onClick={() => setOpen(true)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {/* location flag for 100m */}
                        {haversine(
                          {
                            lat: d?.startVisitLocation?.lat
                              ? d?.startVisitLocation?.lat
                              : 0,
                            lng: d?.startVisitLocation?.long
                              ? d?.startVisitLocation?.long
                              : 0,
                          },
                          {
                            lat: d?.endVisitLocation?.lat
                              ? d?.endVisitLocation?.lat
                              : 0,
                            lng: d?.endVisitLocation?.long
                              ? d?.endVisitLocation?.long
                              : 0,
                          }
                        ).toFixed(2) < 100
                          ? (<FlagIcon sx={{ color: "green" }} />)
                          : (<FlagIcon sx={{ color: "red" }} />)}
                      </TableCell>
                      <TableCell align="center" style={d.unplanned ? revertedStyle : approvedStyle}>
                        {
                          d?.unplanned ? "Unplanned" : "Planned"
                        }
                      </TableCell>
                      <TableCell align="center" >
                        <Button variant="contained"
                          disabled={
                            d?.visitRemark.map((v, i) => {
                              if (v?.role == user?.role) return true
                              return false
                            }).includes(true)
                          }
                          onClick={() => {
                            setAddRemark(true);
                            setVisitId(d?._id)
                          }}>Add remark</Button>
                      </TableCell>
                    </TableRow>
                  ))
                  :
                  <Box sx={{ textAlign: 'left', pt: 1 }}>
                    <Typography variant="h6" sx={{ p: 1 }}>No visits avilable for this SO.</Typography>
                  </Box>}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )
      }

      <Modal open={open} onClose={handleClose}>
        <Box sx={messageStyle}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align='left' sx={{ fontWeight: 'bolder' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bolder' }}>Action Taken</TableCell>
              </TableRow>
            </TableHead>

            {visitDetails?.length > 0 ? (
              visitDetails.map((row) => (
                <TableBody>
                  <TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="left" scope="row" style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>{row?.type}</TableCell>
                    <TableCell align="center" scope="row" style={{
                      borderBottom: '1px solid rgba(224, 224, 224, 1)', display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}>{row?.type === "image-capture" ?
                      <div style={{
                        backgroundImage: `url(${row?.imageCapturedUrl})`,
                        width: '250px',
                        height: '250px',
                        position: "relative",
                      }}>
                        <p style={{ color: "white", position: "absolute", bottom: '0', fontWeight: "bolder", textAlign: "center" }}>
                          {row?.locationString}
                        </p>
                      </div> : row?.actionTaken}</TableCell>
                  </TableRow>
                </TableBody>))
            ) :
              <Box sx={{ textAlign: 'left', pt: 2 }}>
                <Typography variant="h4">No Visit Action Available.</Typography>
              </Box>
            }

          </Table>
          <Box sx={{ m: 3, display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" onClick={() => setOpen(false)}>Close</Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal for location */}
      <Modal open={openLoc} onClose={handleClose}>
        <Box sx={messageStyleLoc}>
          <iframe src={`https://maps.google.com/maps?q=${lat},${long}&hl=es;&output=embed`} height="500px" width="100%"></iframe>
        </Box>
      </Modal>

      <Modal open={addRemark}
        onClose={() => {
          setAddRemark(false);
          setVisitId("")
        }}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '35%',
          height: '30%',
          // maxWidth: 500,
          bgcolor: "white",
          boxShadow: 24,
          p: 2,
          textAlign: 'center'
        }}>
          <h3>Visit Remark</h3>
          <Box style={{ display: 'flex', flexDirection: "column", padding: "1rem" }}>
            <TextField
              type='text'
              // sx={{ width: '80%' }}
              // onChange={() => handleChange()}
              value={visitRemark}
              onChange={(e) => setVisitRemark(e.target.value)}
              // value={selectStartDate}
              name="visitRemark"
              label="Add Visit Remark"
              variant="outlined"
            />

            <Button variant="contained" sx={{ mt: '1.5rem' }} onClick={submitRemark}>
              Submit
            </Button>

            {/* <TextField
              // onKeyPress={handleKeyPress}
              // onChange={handleChange}
              // value={documentCategory}
              name="remark"
              label="Add Visit Remark"
              variant="outlined"
            /> */}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default VisitsList;
